import React, { useState, useEffect, useRef } from "react";
import "./AddEditContent.scss";
import Footer from "../../../component/Footer/Footer";
import Sidebar from "../../Sidebar";
import { Image_Url } from "../../../constants/imageUrl/ImageUrl";
import { useNavigate, useParams } from "react-router-dom";
import { safeDecode } from "../../../common/decoder";
import { useDispatch } from "react-redux";
import { trainingEditAction } from "../../../actions/trainingEditAction";
import { VehicleCategoryAction } from "../../../actions/partcatelogueAction";
import { getVehicleAction } from "../../../actions/getVehicle";
import Loader from "../../../component/loaderComponent/Loader";
import { updateContentAction } from "../../../actions/trainingAction";
import { NotificationManager } from "react-notifications";
import { getVehiclelist_categoryAction } from "../../../actions/getVehicle";
import { FaCloudDownloadAlt } from "react-icons/fa";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';
import { fileType } from "../../../constants/filetype/filetype";
import { Modal } from "react-bootstrap";
import PopupConfirmation from "../../../component/PopupConfirmation/PopupConfirmation";
import { hasPermission } from "../../../utils/permissionUtils";
import { PERMISSIONS } from "../../../constants/permissions/Permissions";

const AddEditContent = () => {
  const { id } = useParams();
  const decodeid = safeDecode(id);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    attachment: "",
    attachment_type: "",
    description: "",
    title: "",
    type: "",
    vehicle_list: [],
    vehicle_category: "",
    ContentType: "",
    file_name: ""
  });
  const [staticState, setStaticState] = useState({
    attachment: "",
    attachment_type: "",
    description: "",
    title: "",
    type: "",
    vehicle_list: [],
    vehicle_category: "",
    ContentType: "",
    file_name: ""

  });
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  const [ContentType, setContentType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [getVehicleList, setGetVehicleList] = useState([]);
  const [getVehiclecatList, setGetVehiclecatList] = useState([]);
  const navigate = useNavigate();
  function handleContentTypeChange(event) {
    setContentType(event.target.value);
  }

  useEffect(() => {
    editTraining();
    handleChangeLanguage(language);
  }, []);
  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  useEffect(() => {
    VehicleCategoryListData();
    VehicleListData();
    if (state.vehicle_category) {
      CategoryVehicleListData(state?.vehicle_category);
    }
    setTitle((state?.title)?.length || 0);
    setDescription((state?.description)?.length || 0);
  }, [state?.vehicle_category]);

  const handleDownloadFile = () => {
    let fileURL;

    if (selectedFile) {
      fileURL = encodeURIComponent(selectedFile);
    } else if (state.attachment) {
      fileURL = encodeURIComponent(state.attachment);
    } else {
      return "No file to download";
    }
    window.location.href = decodeURIComponent(fileURL);
  };

  const handleChangeDropdown = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue.includes("all")) {
      if (state.vehicle_list.length === getVehiclecatList.length) {
        setState((prevState) => ({
          ...prevState,
          vehicle_list: [],
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          vehicle_list: getVehiclecatList,
        }));
      }
    } else {
      // Remove "All" from the selected options
      const filteredValues = selectedValue.filter((value) => value !== "all");

      if (filteredValues.length === 1) {
        setState((prevState) => ({
          ...prevState,
          vehicle_list: filteredValues,
        }));
      } else if (filteredValues.length > 1) {
        const finalArr = filteredValues.filter((data) => {
          return filteredValues.filter((item) => data.id === item.id).length === 1;
        });

        setState((prevState) => ({
          ...prevState,
          vehicle_list: finalArr,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          vehicle_list: [],
        }));
      }
    }
  };

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    if (name === "vehicle_category") {
      const selectedCategory = value.replace(/^ +/gm, "");
      const availableVehicles = getVehiclecatList.filter((vehicle) => vehicle.categoryId === selectedCategory);

      setState({
        ...state,
        vehicle_category: selectedCategory,
        vehicle_list: [],
        noVehicles: availableVehicles.length === 0,
      });
    } else {
      setState({
        ...state,
        [name]: value.replace(/^ +/gm, ""),
      });
    }
    updateCharsters();
    updateChars();
  };
  const fileInputRef = useRef(null);
  const handleFileUpload = (event) => {
    const files = event.target.files[0];
    if(!files){
      NotificationManager.error(t('validationmsg.selectfileError'));
      setSelectedFile(null);
      return;
    }
    const allowedExtensions = {
      pdf: fileType.PDF.extension,
      video: fileType.VIDEO,
      scorm: fileType.SCORM,
    };
    const selectedFileType = state.attachment_type;
    if (!selectedFileType && allowedExtensions[selectedFileType]) {
      NotificationManager.error(t('validationmsg.selectfiletype'));
      setSelectedFile(null);
      return;
    }
    const allowedExtensionsForFileType = allowedExtensions[selectedFileType];
    const fileExtension = files.name.split('.').pop();

    if (!allowedExtensionsForFileType.includes(`.${fileExtension.toLowerCase()}`)) {
      NotificationManager.error(t('validationmsg.invalidfilytype'));
      setSelectedFile(null);
      return;
    }
    setSelectedFile(files);
  };

  async function CategoryVehicleListData(id) {
    let response = await dispatch(getVehiclelist_categoryAction(id));
    if (response == 200 || response != null) {
      setGetVehiclecatList(response.data.data.results);
    }
  }

  const [vehicleList, setVehicleList] = useState([]);

  async function VehicleCategoryListData() {
    let response = await dispatch(VehicleCategoryAction());
    if (response == 200 || response != null) {
      setVehicleList(response.data.data.results);
    } else if (response === undefined) {
    }
  }

  async function VehicleListData() {
    let response = await dispatch(getVehicleAction());
    if (response == 200 || response != null) {
      setGetVehicleList(response.data.data.results);
      setTitle((response?.data?.data?.title)?.length)
      setDescription((response?.data?.data?.description)?.length)
    }
  }

  async function editTraining() {
    setIsLoading(true);
    let response = await dispatch(trainingEditAction(decodeid));
    if (response == 200 || response != null) {
      setState({
        attachment: response.data?.data?.attachment,
        attachment_type: response.data?.data?.attachment_type.toLowerCase(),
        description: response.data?.data?.description,
        title: response.data?.data?.title,
        type: response.data?.data.type,
        vehicle_list: response.data.data?.vehicle_list.map(({ vehicle_id, ...item }) => ({ id: vehicle_id, ...item })),
        vehicle_category: response.data.data?.vehicle_list[0]?.vehicle_category_id,
        file_name: response.data?.data?.file_name
      });
      setStaticState({
        attachment: response.data?.data?.attachment,
        attachment_type: response.data?.data?.attachment_type.toLowerCase(),
        description: response.data?.data?.description,
        title: response.data?.data?.title,
        type: response.data?.data.type,
        vehicle_list: response.data.data?.vehicle_list.map(({ vehicle_id, ...item }) => ({ id: vehicle_id, ...item })),
        vehicle_category: response.data.data?.vehicle_list[0]?.vehicle_category_id,
        file_name: response.data?.data?.file_name
      })
      setIsLoading(false);
    }
  }

  const updatecontentTutorial = async () => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("description", state.description);
    formData.append("type", state.type);
    { state.vehicle_list?.map((data) => formData.append("vehicle_ids", data.id)) }
    formData.append("title", state.title);
    if (selectedFile) {
      formData.append("attachments.attachment_type", state.attachment_type);
      formData.append("attachments.attachment", selectedFile);
    }
    let response = await dispatch(updateContentAction(formData, decodeid));
    if (response == 200 || response != null) {
      NotificationManager.success(response.data.message);
      setIsLoading(false);
      navigate("/productTraining");
      window.scroll(0, 0);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  };
  const [description, setDescription] = useState(0);
  const [title, setTitle] = useState(0);
  function updateCharsters() {
    const text = document.getElementById("text2").value;
    setTitle(text?.length);
  }
  function updateChars() {
    const text = document.getElementById("text").value;
    setDescription(text?.length);
  }
  const [confirmationPopupShow, setConfirmationPopupshow] = useState(false);
  const handleConfirmationPopup = () => {
    setConfirmationPopupshow(true);
  };
  const handleEditContentPopupCloseButtons = () => {
    if(
      JSON.stringify(state)===JSON.stringify(staticState)
    ){
      navigate("/producttraining")
    }
    else{
      setConfirmationPopupshow(true);
    }
  };
  const closeAddContentConfirmationPopupClose = () => {
    setConfirmationPopupshow(false);
  };

  return (
    <div className="AddEditContent_containers">
      <div className="AddEditContent_container">
        <div className="AddEditContentcontent">
          <div className="header_border">
            <p className="pgm-list-header-text">TVS &gt; {t('tutorialtraining.tutorial')} &gt; {t('tutorialtraining.editcontent')}</p>
          </div>
          <div className="AddEditContent_panel">
            <div className="panel-all">
              {t('tutorialtraining.editcontent')}
              <button
                className="AddEditContent_Close"
                onClick={handleEditContentPopupCloseButtons}
              >
                {t('addparts.close')}
              </button>
            </div>
          </div>

          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="hero-section">
                <div className="hero-section_div">
                  <div class="input-wrapper">
                    <label className="required" for="first">{t('tutorialtraining.selecttypecontent')}</label>
                    <select
                      name="type"
                      value={state.type}
                      onChange={handleChange}
                      required
                    >
                      <option value="">{t('tutorialtraining.selecttype')} </option>
                      <option value="tutorial">{t('tutorialtraining.tutorial')}</option>
                      <option value="trouble_shooting">{t('tutorialtraining.troubleshooting')}</option>
                    </select>
                  </div>
                </div>
                <div className="hero-section_div">
                  <div class="input-wrapper">
                    <label className="required" for="first">{t('tutorialtraining.selectvehiclecategory')}</label>
                    <select
                      name="vehicle_category"
                      value={state.vehicle_category}
                      onChange={handleChange}
                      required
                    >
                      <option value="">{t('tutorialtraining.vehiclecategory')} </option>
                      {vehicleList.map((data) => (
                        <option value={data.id}>{data.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="hero-section_div">
                  <div class="input-wrapper">
                    <FormControl className="multiselect_part">
                      <InputLabel className="multiselect-label required" htmlFor="vehicle_list">{t('addcatalogues.selectvehicle')}</InputLabel>
                      <Select className="multipleSelect_part"
                        multiple
                        name="vehicle_list"
                        inputProps={{ className: 'multiselect_input' }}
                        value={state.vehicle_list}
                        onChange={handleChangeDropdown}
                        renderValue={(selected) => {
                          const alreadySelected = state?.vehicle_list.map((item) => item.name)
                          return alreadySelected.join(', ')
                        }
                        }
                      >
                        {getVehiclecatList.length > 0 && (
                          <MenuItem key="all" value="all">
                            <Checkbox checked={state.vehicle_list.length === getVehiclecatList.length} />
                            <ListItemText primary="All" />
                          </MenuItem>
                        )}
                        {getVehiclecatList.map((data) => (
                          <MenuItem key={data.id} value={data}>
                            <Checkbox checked={state.vehicle_list?.some((item) => item.id === data.id)} />
                            <ListItemText primary={data.name} />
                          </MenuItem>
                        ))}
                        {getVehiclecatList.length === 0 && state.vehicle_list.length === 0 && (
                          <MenuItem disabled>
                            <ListItemText primary="No vehicle" />
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="title-input">
                <div class="input-wrapper">
                  <label className="required" for="first">{t('tutorialtraining.contenttitle')}</label>
                  <div className="">
                    <textarea
                      type="text"
                      placeholder={t('tutorialtraining.entertitle')}
                      defaultValue={state.title}
                      name="title"
                      onInput={handleChange}
                      className="text-field"
                      rows={10}
                      cols={50}
                      id="text2"
                      maxLength={100}
                    />
                    <p className='AddEditContent-content-title montserrat-font'>{(state?.title)?.length || 0}/100</p>
                  </div>
                </div>
              </div>
              <div className="title-input">
                <div class="input-wrapper">
                  <label className="required" for="first">{t('tutorialtraining.description')}</label>
                  <div className="">
                    <textarea
                      type="text"
                      className="text-description"
                      placeholder={t('tutorialtraining.enterdescription')}
                      defaultValue={state.description}
                      name="description"
                      onInput={handleChange}
                      rows={10}
                      cols={50}
                      id="text"
                      maxLength={500}
                    />
                    <p className='AddEditContent-content-description montserrat-font'>{(state?.description)?.length || 0}/500</p>

                  </div>
                </div>
              </div>
              <div className="multiple_input">
                <div className="content-type">
                  <div class="input-wrapper">
                    <label className="required" for="first">{t('tutorialtraining.selectfiletype')}</label>
                    <select
                      name="attachment_type"
                      value={state.attachment_type}
                      onChange={handleChange}
                      required
                    >
                      <option value="video">Video </option>
                      <option value="pdf">PDF</option>
                      {/* <option value="scorm">Scorm</option> */}  {/* To do enable later */}
                    </select>
                  </div>
                </div>
                <div className="select-file selectfileeditcontent">
                  <div class="input-wrapper">
                    <label className="required" for="first" htmlFor="formId">
                      {t('addcatalogues.selectfile')}
                    </label>
                    {/* <div className="selectfileeditcontent">
                      <input
                        type="text"
                        readOnly
                        value={state.attachment}
                        className="text-field"
                      />
                    </div> */}
                    <input
                      className="text-field"
                      name=""
                      type="file"
                      ref={fileInputRef}
                      id="formId"
                      hidden
                      accept={
                        state.attachment_type === "pdf"
                          ? ".pdf"
                          : state.attachment_type === "video"
                            ? ".mp4"
                            : state.attachment_type === "scrom"
                              ? ".zip"
                              : ""
                      }
                      readOnly
                      onChange={handleFileUpload}
                    />
                    <input
                      type="text"
                      className="text-field upload_inp"
                      readOnly
                      placeholder=""
                      value={selectedFile?.name || state.file_name}
                    />
                  </div>
                  <div className="upload-btn-flex">
                    <span
                      className="upload_text"
                      onClick={() => fileInputRef.current.click()}
                    >
                      {t('addcatalogues.upload')}
                    </span>
                    <button className="upload-download-button" onClick={handleDownloadFile} >
                      <FaCloudDownloadAlt />
                    </button>
                  </div>
                </div>
              </div>
              <div className="file-suggestion">
                {t('tutorialtraining.fileformatsupport')}
              </div>
              <div className="AddEditContent_panel">
                <div className="panel-all">
                  {hasPermission(PERMISSIONS.CAN_UPDATE_TRAINING_TUTORIAL) && (
                    <button
                      className="AddEditContent_submit"
                      onClick={handleConfirmationPopup}
                      disabled={
                        state?.file_name === null ||
                        state?.title === "" ||
                        state?.description === "" ||
                        state?.attachment_type === "" ||
                        state?.type === "" ||
                        state?.vehicle_category === "" ||
                        state?.vehicle_list === "" ||
                        getVehiclecatList?.length === 0 ||
                        state.vehicle_list.length === 0
                      }
                    >
                      {t('editparts.update')}
                    </button>
                  )}
                </div>
              </div>
            </>
          )}
          <div className="footer_div">
            <Footer />
          </div>
        </div>
      </div>
      <Modal
        className="expertise-modal"
        show={confirmationPopupShow}
        onHide={closeAddContentConfirmationPopupClose}
      >
        <Modal.Body>
          {confirmationPopupShow && (
            <PopupConfirmation
              handleConfirmationPopupClose={closeAddContentConfirmationPopupClose}
              onSaveClick={updatecontentTutorial}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddEditContent;
